import React from 'react';

import { Row } from '@cuemath/comps';
import { Message } from 'semantic-ui-react';

import { FlexView } from '@cuemath/comps';
import { Grid } from 'semantic-ui-react';

import { LabelWrapper, LinkWrapper, ValueWrapper } from './styled-components';

const InfoViewLabel = ({ resource }) => {
  return (
    <Row>
      <Message negative>
        <div>
          <h1>
            <b>{resource} PII viewed</b>
          </h1>
          <section>
            <h3>
              Your email ID is getting recorded in our system for security purposes as you
              are viewing important personal information.
            </h3>
          </section>
        </div>
      </Message>
    </Row>
  );
};

const LinkContainer = (label = '', value = () => {}, width = 8) => {
  return (
    <Grid.Column width={width}>
      <LinkWrapper onClick={value}>{label}</LinkWrapper>
    </Grid.Column>
  );
};

const DetailsContainer = (label = '', value = '') => {
  return (
    <FlexView>
      <LabelWrapper weight="bold">{label}</LabelWrapper>
      <ValueWrapper>{value}</ValueWrapper>
    </FlexView>
  );
};

const FieldContainer = (label = '', value = '', width = 8) => {
  return <Grid.Column width={width}>{DetailsContainer(label, value)}</Grid.Column>;
};

export { FieldContainer, LinkContainer, InfoViewLabel };
